import React, { Component } from "react";
import { Row, Col, Image, Button } from "react-bootstrap";
import hyperlinks from "../../../src/util/hyperlinks";



export default class InnovationAreaCard extends Component {
    render() {
        return(
            <Col md={6}>
                <div className="innovation-area" data-card-id={this.props.cardId}>
                    <Image src={this.props.innovationArea.icon} circle />
                    <div className="name">{this.props.innovationArea.name}</div>
                    <p className="description" style={{ height: this.props.height }}>{this.props.innovationArea.description}</p>
                    <Button href={`${hyperlinks["currentMembers"]}?innovation_area=${this.props.innovationArea.id}`}>See members involved in this innovation area</Button>
                </div>
            </Col>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/InnovationAreaCard.jsx.erb